(function () {
  'use strict';

  var header;
  var headerObserver;
  var headerResizeObserver;
  var frame;

  function setProperty(element, name, value) {
    if (element.style.getPropertyValue(name) !== value) element.style.setProperty(name, value);
  }

  function scheduleSync() {
    if (!frame) frame = window.requestAnimationFrame(sync);
  }

  function observeHeader() {
    var current = document.getElementById('SiteHeader');
    if (current === header) return;
    if (headerObserver) headerObserver.disconnect();
    if (headerResizeObserver) headerResizeObserver.disconnect();
    header = current;
    if (!header) return;
    headerObserver = new MutationObserver(scheduleSync);
    headerObserver.observe(header, { attributes: true, attributeFilter: ['class', 'style'] });
    if (window.ResizeObserver) {
      headerResizeObserver = new ResizeObserver(scheduleSync);
      headerResizeObserver.observe(header);
    }
  }

  function sync() {
    frame = null;
    observeHeader();
    var mobile = window.matchMedia('(max-width: 768px)').matches;
    var offset = 0;
    if (mobile && header) {
      var style = window.getComputedStyle(header);
      if (style.position === 'fixed' || style.position === 'sticky') {
        offset = header.offsetHeight + Math.max(0, parseFloat(style.top) || 0);
      }
    }
    setProperty(document.documentElement, '--seerat-mobile-filter-top', offset + 'px');
    if (!mobile) return;
    setProperty(document.documentElement, '--seerat-mobile-filter-width', document.documentElement.clientWidth + 'px');
    document.querySelectorAll('.collection-grid__wrapper > .collection-filter').forEach(function (bar) {
      var left = bar.parentElement.getBoundingClientRect().left;
      setProperty(bar.parentElement, '--seerat-mobile-filter-margin', -left + 'px');
    });
  }

  function init() {
    sync();
    window.addEventListener('resize', scheduleSync);
    document.addEventListener('shopify:section:load', scheduleSync);
    // Native filter/sort requests replace the toolbar with fresh section markup.
    new MutationObserver(scheduleSync).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
